<template>
  <div class="voz-expression-profile-content" id="identidade-verbal-voz-perfil-das-expressoes" data-search-anchor>
    <p class="voz-expression-profile-paragraph-title">{{ vozExpressionProfileParagraphTitle }}</p>

    <div class="voz-line-expression-profile-svg-container">
      <svg width="588" height="14" viewBox="0 0 588 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 14V0.5H587.5V14" stroke="black" />
      </svg>
    </div>

    <div class="voz-expression-profile-wrapper">
      <div class="voz-commercial-dynamic-container">
        <div class="voz-commercial-dynamic-wrapper">
          <div class="icon-wrapper">
            <IconCheck />
            <p class="voz-commercial-dynamic-paragraph">{{ vozComercialeDynamicParagraph }}</p>
          </div>
        </div>
      </div>

      <div class="voz-institutional-structured-container">
        <div class="voz-institutional-structured-wrapper">
          <div class="icon-wrapper">
            <IconCheck />
            <p class="voz-institutional-structured-paragraph">{{ vozInstitutionalStructuredParagraph }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="voz-paragraphs-wapper">
      <p class="voz-expression-profile-paragraph">{{ vozExpressionProfileParagraph1 }}</p>
      <p class="voz-expression-profile-paragraph">{{ vozExpressionProfileParagraph2 }}</p>
      <p class="voz-expression-profile-paragraph">{{ vozExpressionProfileParagraph3 }}</p>
    </div>

    <div class="voz-expression-profile-cards">
      <div v-for="(card, i) in expressionCards" :key="i" class="voz-expression-profile-card"
        :style="{ backgroundImage: `url(${card.image})` }">
        <div class="voz-expression-profile-card-overlay">

          <h1 class="voz-expression-profile-card-number">
            {{ i + 1 }}
          </h1>

          <div class="voz-expression-profile-card-content">
            <h3 class="voz-expression-profile-card-title">
              {{ card.title }}
            </h3>
            <p class="voz-expression-profile-card-text">
              {{ card.text }}
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class VozExpressionProfileSection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozExpressionProfileParagraphTitle(): string {
    return this.getElementText(3, 0)
  }

  get vozComercialeDynamicParagraph(): string {
    return this.getElementText(3, 1)
  }

  get vozInstitutionalStructuredParagraph(): string {
    return this.getElementText(3, 2)
  }

  get vozExpressionProfileParagraph1(): string {
    return this.getElementText(3, 3)
  }

  get vozExpressionProfileParagraph2(): string {
    return this.getElementText(3, 4)
  }

  get vozExpressionProfileParagraph3(): string {
    return this.getElementText(3, 5)
  }

  get expressionCards() {
    const base = 6

    return [0, 1, 2, 3].map(i => ({
      image: this.getElementMedia(3, base + i),
      title: this.getElementTitle(3, base + i),
      text: this.getElementText(3, base + i)
    }))
  }

  async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.voz-expression-profile-content {
  display: grid;
  justify-content: center;
  margin-top: 35px;
  max-width: 1032px;
}

.voz-expression-profile-paragraph-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  margin: 0 auto;
}

.voz-line-expression-profile-svg-container {
  max-width: 1032px;
  margin-top: 9.5px;
  display: flex;
  justify-content: center;
}

.voz-expression-profile-cards {
  width: 1032px;
  height: 494px;
  margin-top: 32px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.voz-expression-profile-card {
  border-radius: 16px;
  overflow: hidden;

  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;

  position: relative;
}

.voz-expression-profile-card-overlay {
  position: absolute;
  inset: 0;

  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;

  color: white;
}

.voz-expression-profile-card-content {
  display: flex;
  flex-direction: column; 
  margin-bottom: 16px;  
}

.voz-expression-profile-card-number {
  font-size: 145px;
  line-height: 1;
  font-weight: 400;
  line-height: 0.9;
  margin: 0; 
}

.voz-expression-profile-card-title {
  font-family: GlobotipoCorporativaRegular;
  font-size: 20px;
  font-weight: 400;
  width: 145px;
  margin-top: 0;
  margin-bottom: 10px;
}

.voz-expression-profile-card-text {
  font-family: GlobotipoCorporativaTextosRegular;
  font-size: 13px;
  line-height: 14px;
  margin-top: 0;
  margin-bottom: 0;  
  width: 150px;
}

.voz-expression-profile-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 495px);
  gap: 38px;
}

.voz-commercial-dynamic-wrapper {
  padding-top: 32px;
  padding-left: 108px;
}

.voz-institutional-structured-wrapper {
  padding-top: 32px;
  padding-left: 90px;
}

.voz-commercial-dynamic-container,
.voz-institutional-structured-container {
  width: 495px;
  height: 102px;
  background-color: #f0f0f0;
  border-radius: 16px;
  margin-top: 24px;
  margin-bottom: 50px;
}


.voz-commercial-dynamic-paragraph,
.voz-institutional-structured-paragraph {
  font-weight: 600;
  font-size: 16px;
  padding-left: 8px;
  margin: 0;
}

.voz-expression-profile-paragraph {
  width: 503px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
}

.voz-expression-profile-paragraph:first-of-type {
  margin-top: 0;
}
</style>
